import Vue from 'vue';
import moment from 'moment';
import { Pipe } from '../constants/pipe';
import { DateFormat } from '../constants/dateFormat';
import { HashedBookingDataInterface } from '@/types/pages/landing/hashedBookingDataInterface';

export default Vue.mixin({
  methods: {
    parseHashedBookingData(): HashedBookingDataInterface | undefined {
      if (window.location.hash) {
        const hash: string = window.location.hash.replace('#', '');
        const params: Array<string> = hash.split(Pipe.BookingDataHash);
        if (moment(params[0], DateFormat.VueDate).isValid() && moment(params[1], DateFormat.VueDate).isValid()) {
          const hashedParams: HashedBookingDataInterface = {
            checkin: params[0],
            checkout: params[1],
            guests_number: params[2] ? +params[2] : 1,
          };
          if (params[3]) {
            hashedParams['meal_option'] = +params[3];
          }
          if (params[4]) {
            hashedParams['room_type_hid'] = params[4];
          }
          return hashedParams;
        }
      }
      return undefined;
    },
  },
});
